import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { BattleBoatPlayerStatus } from 'src/app/gamification/command-center/services/challenge-battle-ship.service';

const DEFEAT_TEXTS = {
  title: 'better_luck_next',//Better luck next time.
  description: 'all_ship_have_been_sunken', //All your ships have been sunk. Keep challenging your peers to get more rewards.
  winMessage: '',
}

const WIN_TEXTS = {
  title: 'sunk_all_ships', //You sunk all your rival’s ships.
  description: 'rewards_added', // These prizes have been added to your profile.
  winMessage: 'you_win', //You Win!
}

@Component({
  selector: 'cv-challenge-battle-boat-result',
  templateUrl: './challenge-result.component.html',
  styleUrl: './challenge-result.component.scss'
})
export class ChallengeBattleBoatResultComponent implements OnChanges {
  @Input()
  challenge: any = null;

  @Output()
  displayResult: EventEmitter<boolean> = new EventEmitter<boolean>();

  modalFirstOpen: boolean = true;

  displayModal: boolean = false;
  gameStatus: number = 0;

  @Input()
  player: {
    GameStatus: number;
  } = {
    GameStatus: 0,
  };

  textByStatus = {
    [BattleBoatPlayerStatus.DEFEAT]: {
      ...DEFEAT_TEXTS,
    },
    [BattleBoatPlayerStatus.VICTORY]: {
      ...WIN_TEXTS
    }
  };

  constructor() {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.player?.currentValue?.GameStatus && this.modalFirstOpen) {
      this.gameStatus = changes.player.currentValue.GameStatus;
      this.displayModal = [BattleBoatPlayerStatus.DEFEAT, BattleBoatPlayerStatus.PAID, BattleBoatPlayerStatus.VICTORY].includes(this.gameStatus);
      this.displayResult.emit(this.displayModal);
      this.modalFirstOpen = !this.displayModal;
    }
  }
  closeBattleBoatResult(){
    this.displayResult.emit(false);
    this.displayModal = false;
  }


}
